import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const openWhatsApp = () => {
    window.open('https://wa.me/2250700592164', '_blank', 'noopener,noreferrer');
  };
  return <section className="relative bg-white overflow-hidden pt-16 pb-16 sm:pb-24 lg:pb-32" data-id="element-202">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-203">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 items-center" data-id="element-204">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left" data-id="element-205">
            <div className="inline-flex items-center rounded-full px-3 py-1 text-sm font-semibold text-blue-600 bg-blue-50 mb-6 border border-blue-100" data-id="element-206">
              <span className="flex h-2 w-2 rounded-full bg-blue-600 mr-2" data-id="element-207"></span>
              Nouvelle Carte Visa USD
            </div>
            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl" data-id="element-208">
              <span className="block xl:inline" data-id="element-209">
                Votre Carte Visa Virtuelle USD rechargeable par Wave
              </span>
            </h1>
            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0" data-id="element-210">
              Une solution complète pour les entreprises et particuliers. Payez
              en ligne sans limites, sans frontières.
            </p>
            <div className="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0" data-id="element-211">
              <button onClick={openWhatsApp} className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 md:text-lg md:px-10 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-212">
                Obtenir ma carte USD
                <ArrowRight className="ml-2 -mr-1 h-5 w-5" data-id="element-213" />
              </button>
            </div>

            <div className="mt-8 flex items-center justify-center lg:justify-start gap-6 text-gray-400 grayscale opacity-70" data-id="element-214">
              <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-8" data-id="element-215" />
              <div className="h-6 w-px bg-gray-300" data-id="element-216"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fvnnGxgmk5oP7VX6ro2Hkq/pasted-image.png" alt="Wave" className="h-8" data-id="element-217" />
            </div>
          </div>

          <div className="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center" data-id="element-218">
            <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md" data-id="element-219">
              <div className="relative block w-full bg-white rounded-lg overflow-hidden" data-id="element-220">
                <img className="w-full" src="https://cdn.magicpatterns.com/uploads/t7ebDoXyJPZ2AXqrueaCkK/device-tarjeta-virtual-usa-en.jpg" alt="Virtual Card App Interface" data-id="element-221" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-blue-50 blur-3xl opacity-50 pointer-events-none" data-id="element-222"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-indigo-50 blur-3xl opacity-50 pointer-events-none" data-id="element-223"></div>
    </section>;
}